import { render } from "./Stat.vue?vue&type=template&id=61e39944&scoped=true"
import script from "./Stat.vue?vue&type=script&lang=js"
export * from "./Stat.vue?vue&type=script&lang=js"

import "./Stat.vue?vue&type=style&index=0&id=61e39944&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e39944"]])

export default __exports__